import { render, staticRenderFns } from "./GDanReplyAudit.vue?vue&type=template&id=0d08a620&scoped=true&"
import script from "./GDanReplyAudit.vue?vue&type=script&lang=js&"
export * from "./GDanReplyAudit.vue?vue&type=script&lang=js&"
import style0 from "./GDanReplyAudit.vue?vue&type=style&index=0&id=0d08a620&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d08a620",
  null
  
)

export default component.exports